import { j as t } from "./kezios-design-system.esm172.js";
import { Flex as x, Stack as l, Text as r } from "@mantine/core";
import { RingIcon as m } from "./kezios-design-system.esm124.js";
import { Spacing as e } from "./kezios-design-system.esm135.js";
const j = ({
  title: n,
  description: i,
  icon: o,
  titleComponent: c,
  cta: s
}) => /* @__PURE__ */ t.jsxs(x, { direction: "column", gap: e.s5, align: "center", w: "300px", children: [
  /* @__PURE__ */ t.jsx(m, { icon: o, size: 24, color: "primary" }),
  /* @__PURE__ */ t.jsxs(l, { gap: e.s2, children: [
    /* @__PURE__ */ t.jsx(
      r,
      {
        style: { textAlign: "center" },
        variant: "textXl.semibold",
        c: "gray.9",
        component: c,
        children: n
      }
    ),
    /* @__PURE__ */ t.jsx(r, { style: { textAlign: "center" }, variant: "textMd", c: "gray.6", children: i })
  ] }),
  s
] });
export {
  j as Item
};
